class NetworkError extends Error {
  constructor(message, data) {
    super(message);
    this.name = 'NetworkError';
    this.data = data;
  }
}

const asyncFetch = async (url, options = {}) => {
  try {
    const { method = 'GET', headers = {}, body } = options;
    const response = await fetch(url, {
      method,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers,
      },
      body: body && JSON.stringify(body),
    });
    const data = await response.json();

    if (!response.ok) {
      throw new NetworkError(data.error, data);
    }

    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default asyncFetch;
